/* eslint-disable @typescript-eslint/no-unused-vars */
// import { IAuthenticationService, TokenIAuthenticationService } from "@/interfaces/IAuthenticationService";
// import { baContainer } from "@/ioc";
import axios, { AxiosResponse } from "axios";
import { IAuthenticationService, TokenIAuthenticationService, baContainer } from "..";

let tokenGlobal: string | undefined = undefined;

if (!window.axiosInstance) {
    window.axiosInstance = axios.create();
    window.axiosInstance.defaults.headers.common["IsFrom"] = `Outlook Add-in`;
    //config for every axios request with UserIdentityToken from Office.js
    window.axiosInstance.interceptors.request.use(async (config: any) => {
      if(!tokenGlobal) {
        const authenticationService: IAuthenticationService = baContainer.resolve(
          TokenIAuthenticationService
        );
        tokenGlobal = await authenticationService.GetUserIdentityToken();
      }
      // const token =
      // "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6Ik1HTHFqOThWTkxvWGFGZnBKQ0JwZ0I0SmFLcyJ9.eyJhdWQiOiIzMmVhN2I5Yy1kZGI0LTQ4OWQtYmQyNC0yODY0MDM5OTJlODYiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vMTgxYmU3MDEtODc0MC00ZmJkLWI5MGYtZmVkNTYyMjViN2M4L3YyLjAiLCJpYXQiOjE3MjA0MDg2MTEsIm5iZiI6MTcyMDQwODYxMSwiZXhwIjoxNzIwNDEzNDIwLCJhaW8iOiJBVVFBdS84WEFBQUFVV1JFcjVxT2Z5U3BqajZmMFN2eGgvdWZSd0hscDl1dHN6UHRTK2pyekJZWS8rcVJVa3ZiRVlBSUZVOHEwNlZwL2pSMjJYM2p3aFBmVEZVS3hkWFZkdz09IiwiYXpwIjoiYmM1OWFiMDEtODQwMy00NWM2LTg3OTYtYWMzZWY3MTBiM2UzIiwiYXpwYWNyIjoiMCIsIm5hbWUiOiJQVkQiLCJvaWQiOiJhY2RjNWY5OS1jMjQ2LTRiNzAtYWY2Ny0zMGFjY2I0ZTFmMTgiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJwdmRAYW9wYmEub25taWNyb3NvZnQuY29tIiwicmgiOiIwLkFYRUFBZWNiR0VDSHZVLTVEXzdWWWlXM3lKeDc2akswM1oxSXZTUW9aQU9aTG9iQUFJcy4iLCJzY3AiOiJhY2Nlc3NfYXNfdXNlciIsInN1YiI6IlBPN3BLTDQxU1VjVXdreG1GVG9XYmJFREdBdVhwRjE3aTlUcXhibjByNm8iLCJ0aWQiOiIxODFiZTcwMS04NzQwLTRmYmQtYjkwZi1mZWQ1NjIyNWI3YzgiLCJ1dGkiOiJTS0J5d3gzUEtrV2RaeTZmZ3c2QkFBIiwidmVyIjoiMi4wIn0.se0STfqBiRYv8Dby8TPapSA2kMq-ZPWh-psfBBtTbsIRTG-G_Dsp7zEZrccjUAqAzajUIvlPdh7kaUMhb15xl4wjKf-jniqmruV8fF6MuP51flJ4WHGQ14sS9fwAD3RJ5obwuJiOZ4tU_2UG4fKvlOs_89BE6g5hXRe3Ab_kJMMAWry79l6rmEWlYzmVuH65FamtLFSWz1PFRy8LLLxFvFC-1BOR_nN1KRG-_V9jPD0vIyVqMwKt0lBbMwFSISNJQcqD_I9G-qvkGmNaXlbj46OirTF0jQNs70QCImx-iZBxM-WQPPqTcIZGTOPfG5k13ywHPNbV6-m68gjEB5af7A";       
      if (tokenGlobal) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + tokenGlobal;
        if(config.headers) {
          config.headers.Authorization = "Bearer " + tokenGlobal;
          config.headers.set("IsFrom", `Outlook Add-in`);
        }
      }
      return config;
    });
  
    // Response interceptor for API calls
    // if API return 401, will retrive token again
    // window.axiosInstance.interceptors.response.use(
    //   (response: AxiosResponse) => {
    //     return response;
    //   },
    //   async function (error: any) {
    //     const originalRequest = error.config;
    //     if (error?.response?.status === 401 && !originalRequest?._retry) {
    //       originalRequest._retry = false;
    //       const token = sessionStorage.getItem("token");
    //       if (token != null) {
    //         axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    //         originalRequest.headers.Authorization = "Bearer " + token;
    //         originalRequest.headers.set("IsFrom", `Office Add-in`);
    //       }
    //       return window.axiosInstance(originalRequest);
    //     }
    //   }
    // );
  }

  export default window.axiosInstance;